import React from "react";

const DayBox = ({ days, handleDayClick, isDayClicked }) => {
  return (
    <div className="flex flex-wrap items-center gap-2 mt-2">
      {days?.map((d) => (
        <div
          key={d}
          className={`w-[42px] h-[34px] sm:w-[50px] sm:h-[38px] md:w-[60px] md:h-[44px] border-[1.5px] rounded-[5px] ${isDayClicked(d)
            ? "border-[#00ADEF] bg-[#EBF9FE] text-[#00ADEF] font-[500]"
            : "border-[#D9D9D9] bg-white text-[#303030] font-[400]"
            } flex justify-center items-center font-poppins text-[12px] sm:text-[14px] cursor-pointer transition-all hover:border-[#00ADEF]`}
          onClick={() => {
            handleDayClick(d);
          }}
        >
          {d.slice(0, 3)}
        </div>
      ))}
    </div>
  );
};

export default DayBox;
